import {Observable} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {Branch} from './branch.types';
import {ApiService} from '@aviary/services/api.service';
import {contextWithErrorHandlerForGetAuthBranch} from './branch.handlers';

@Injectable({providedIn: 'root'})
export class BranchService {

  private readonly apiService: ApiService = inject(ApiService);

  public getAuthBranch(branchId: number): Observable<Branch> {
    const endpoint: string = `patrons/v5/branches/${branchId}`;
    return this.apiService.getSingleObject(endpoint, {context: contextWithErrorHandlerForGetAuthBranch()});
  }

  public getBranches(): Observable<Branch[]> {
    const endpoint: string = 'public/v1/branches';

    return this.apiService.get(endpoint);
  }

  public loadPickupLocations(): Observable<Branch[]> {
    const endpoint: string = 'public/v1/branches/pickup-locations';

    return this.apiService.getObjects(endpoint);
  }
}
